import { createFileRoute } from '@tanstack/react-router';
import WeeklyReportPage from '@/modules/peer-support/weekly-report/WeeklyReportPage';
export const Route = createFileRoute('/_authenticated/peer-support/weekly-report')({
  staticData: { title: 'Weekly Peer Support Activity Report' },
  validateSearch: (search: Record<string, unknown>) => ({
    period: typeof search.period === 'string' ? search.period : undefined,
  }),
  component: Page,
});
function Page() {
  const { period } = Route.useSearch();
  return <WeeklyReportPage key={period} period={period} />;
}
